import { Pattern } from "./../../../node_modules/@babel/plugin-transform-private-methods/node_modules/@babel/types/lib/index-legacy.d";
import { replacePhoneNumberToHash, toPattern } from "../Helper";
import PhoneCodes from "../PhoneCodes";
import { Mask } from "./Mask";
import { masks } from "./masks";

export class PhoneMask implements Mask {
  searchValue = masks.celphone.searchValue;
  replaceValue = masks.celphone.replaceValue;
  maxLength = 11;

  maxPhoneLength = 10;

  execute(value: string): string {
    // Remove qualquer caractere que não seja número
    let numericValue = value.replace(/\D/g, "");

    // Limita ao tamanho máximo permitido (11 dígitos)
    const limitedValue = numericValue.substring(0, this.maxLength);

    // Aplica a máscara com base no tamanho
    if (limitedValue.length === this.maxPhoneLength) {
      this.searchValue = masks.phone.searchValue;
      return this.format(limitedValue);
    }

    if (limitedValue.length === this.maxLength) {
      this.searchValue = masks.celphone.searchValue;
      return this.format(limitedValue);
    }

    return limitedValue;
  }

  format(value: string): string {
    return value.replace(this.searchValue, this.replaceValue).trim();
  }

  formatWithCountry(phone: string, country_code: string): string {
    const phoneCode = PhoneCodes.find((elem) => elem.dial_code == country_code);

    const pattern = PhoneCodes.find(
      (elem) => elem.dial_code == country_code
    )?.mask;

    let phoneNumber: String = "";
    if (pattern) {
      phoneNumber =
        country_code === "+55"
          ? this.format(phone)
          : this.formatForeignCountryNumber(
              phone,
              this.replacePhoneNumberToHash(pattern)
            );
    }

    return `${phoneCode?.flag} ${phoneCode?.dial_code} ${phoneNumber}`;
  }

  private formatForeignCountryNumber(value: string, pattern: string): string {
    let newString = "";
    let stringIndex = 0;
    const patternCount = pattern.length;
    for (var i = 0; i < patternCount; i++) {
      if (value[stringIndex]) {
        if (pattern[i] == "#") {
          newString = `${newString}${value[stringIndex]}`;
          stringIndex++;
        } else {
          newString = `${newString}${pattern[i]}`;
        }
      }
    }
    return newString;
  }

  private replacePhoneNumberToHash(text: string): string {
    let res = "";

    if (text) {
      for (let i = 0; i < text.length; i++) {
        if (text[i] === "9") {
          res += "#";
        } else {
          res += text[i];
        }
      }
    }

    return res;
  }
}
